// AppliedFiltersBar.tsx
import React from 'react'
import { Card, Space, Tag, Typography, Divider, Button, Tooltip } from 'antd'
import { FilterOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { isValidArray } from '../../../../../../sprints/components/testReport/testCases/forms/helper'

export const AppliedFilter = ({
    data,
    onClearAll,
    onRemove,
    searchValue = '',
}) => {
    const count =
        (data?.epic?.length ? 1 : 0) +
        (data?.sprint ? 1 : 0) +
        (data?.tags?.length ? 1 : 0) +
        (data?.status ? 1 : 0) +
        (searchValue?.length ? 1 : 0)

    return (
        <Card
            size="small"
            bordered={false}
            bodyStyle={{ padding: 4 }}
            style={{ background: '#fafafa' }}
        >
            <Space align="center" wrap>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FilterOutlined />
                </div>
                <Typography.Text strong>
                    {count} filter{count === 1 ? '' : 's'} applied
                </Typography.Text>

                <Divider type="vertical" />

                {isValidArray(data?.epic) && (
                    <Tag
                        color="blue"
                        closable={!!onRemove}
                        onClose={(e) => {
                            e.preventDefault()
                            onRemove?.('epic')
                        }}
                    >
                        <Typography.Text
                            type="secondary"
                            style={{ fontSize: '12px' }}
                        >
                            Epic:
                        </Typography.Text>{' '}
                        <Typography.Text strong style={{ fontSize: '12px' }}>
                            {data?.epic?.map((t) => t.label).join(', ') ||
                                'N/A'}
                        </Typography.Text>
                    </Tag>
                )}

                {data?.sprint && (
                    <Tag
                        color="geekblue"
                        closable={!!onRemove}
                        onClose={(e) => {
                            e.preventDefault()
                            onRemove?.('sprint')
                        }}
                    >
                        <Typography.Text
                            type="secondary"
                            style={{ fontSize: '12px' }}
                        >
                            Sprint:
                        </Typography.Text>{' '}
                        <Typography.Text strong style={{ fontSize: '12px' }}>
                            {data?.sprint?.label || 'N/A'}
                        </Typography.Text>
                    </Tag>
                )}

                {data?.tags?.length ? (
                    <Tag
                        color="green"
                        closable={!!onRemove}
                        onClose={(e) => {
                            e.preventDefault()
                            onRemove?.('tags')
                        }}
                    >
                        <Typography.Text
                            type="secondary"
                            style={{ fontSize: '12px' }}
                        >
                            Tags:
                        </Typography.Text>{' '}
                        <Typography.Text strong style={{ fontSize: '12px' }}>
                            {data?.tags?.map((t) => t.label).join(', ') ||
                                'N/A'}
                        </Typography.Text>
                    </Tag>
                ) : null}

                {data?.status && (
                    <Tag
                        color="geekblue"
                        closable={!!onRemove}
                        onClose={(e) => {
                            e.preventDefault()
                            onRemove?.('status')
                        }}
                    >
                        <Typography.Text
                            type="secondary"
                            style={{ fontSize: '12px' }}
                        >
                            Status:
                        </Typography.Text>{' '}
                        <Typography.Text strong style={{ fontSize: '12px' }}>
                            {data?.status || 'N/A'}
                        </Typography.Text>
                    </Tag>
                )}
                {searchValue && (
                    <Tag
                        color="geekblue"
                        closable={!!onRemove}
                        onClose={(e) => {
                            e.preventDefault()
                            onRemove?.('search')
                        }}
                    >
                        <Typography.Text
                            type="secondary"
                            style={{ fontSize: '12px' }}
                        >
                            Search:
                        </Typography.Text>{' '}
                        <Typography.Text strong style={{ fontSize: '12px' }}>
                            {searchValue || 'N/A'}
                        </Typography.Text>
                    </Tag>
                )}

                {/* {data.tags?.map((t) => (
                    <Tag
                        key={t.value}
                        color="green"
                        closable={!!onRemove}
                        onClose={(e) => {
                            e.preventDefault()
                            onRemove?.('tag', t.value)
                        }}
                    >
                        <Typography.Text
                            type="secondary"
                            style={{ fontSize: '12px' }}
                        >
                            Tag:
                        </Typography.Text>{' '}
                        <Typography.Text strong style={{ fontSize: '12px' }}>
                            {t.label}
                        </Typography.Text>
                    </Tag>
                ))} */}

                <Divider type="vertical" />

                <Tooltip title="Clear all filters">
                    {/* <Button
                        size="small"
                        type="default"
                        icon={<CloseCircleOutlined />}
                        style={{ backgroundColor: 'red', padding: 4 }}
                        onClick={onClearAll}
                    ></Button> */}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <CloseCircleOutlined onClick={onClearAll} color="red" />
                    </div>
                </Tooltip>
            </Space>
        </Card>
    )
}
